import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Loader } from "@progress/kendo-react-indicators";
import RefreshIcon from "../../../assets/header/refresh.svg";
import ExportIcon from "../../../assets/header/export.svg";
import "./campaign.css";
import { useLocation, useNavigate } from "react-router";
import { TableHeader } from "../../../components/reusableItems/header";
import { PermissionDeninedPage } from "../../../components/reusableItems/permission_denined";
import {
  checkPermission,
  getUserPermission,
} from "../../../config/permission_helper";
import moment from "moment";
import { fetchUserById } from "../../../store/userMgmt";
import { REWARDS_CAMPAIGNS_ADD, REWARDS_CAMPAIGNS_DETAIL, REWARDS_CAMPAIGNS_LIST } from "../../../routes";
import { Reusable_table } from "../../../components/reusableItems/table";
import {
  ConfigData,
  statusConfig,
  statusConfigForPending,
  statusConfigForPublishScheduled,
  statusConfigForPendingNomination,
  statusConfigForCampaignApprover
} from "./configData";
import { ShowDialog } from "../../../components/reusableItems/dialog";
import { Dialog } from "@progress/kendo-react-dialogs";
import { deleteCampaignById, fetchCampaignConfig, fetchCampaigns, generateReward, updateCampaignStatus } from "../../../store/campaign";
import { TextArea, TextBox } from "@progress/kendo-react-inputs";
import { Filter } from "./filter";
import { fetchAllProviderList } from "../../../store/rewardsOperator";

export const RewardCampaignListing = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let { searchQuery } = useLocation();
  const queryParams = new URLSearchParams(searchQuery);
  let delay;

  const { config_list, loading, campaign_list } = useSelector(
    (state) => state.campaigns
  );

  const { provide_list } = useSelector(
    (state) => state.rewardsOperator
  );
  const [tempData, setTempData] = useState([]);
  const [tabStatus, setTabStatus] = useState("");

  const [listLoading, setListingLoading] = useState([]);
  const [showUpdateStatus, setShowUpdateStatus] = useState(false);
  const [tempStatus, setTempStatus] = useState("");
  const [tempOldStatus, setTempOldStatus] = useState("");
  const [tempStatusData, setTempStatusData] = useState([]);
  const [tempStartDate, setTempStartDate] = useState("");
  const [tempEndDate, setTempEndDate] = useState("");

  const [tempDate, setTempDate] = useState("");
  const [rejectReason, setRejectReason] = useState("");
  const [deleteReason, setDeleteReason] = useState("");

  const [tempId, setTempId] = useState("");
  const [actionID, setActionID] = useState("");
  const [actionType, setActionType] = useState("");
  const [timeChange, setTimeChange] = useState(false);
  const [showEndDateError, setShowEndDateError] = useState(false);
  const [showPublishDialog, setShowPublishDialog] = useState(false);

  const [showDelete, setShowDelete] = useState(false);


  const userPermissions = getUserPermission();
  const AddPermssion = checkPermission(
    userPermissions,
    "gamifications.create_campaign"
  ) || false;

  const viewPermssion = checkPermission(
    userPermissions,
    "gamifications.access_campaign"
  );

  const CampaignApproverPermssion = checkPermission(
    userPermissions,
    "gamifications.campaign_approver"
  );

  const AdminPermssion = checkPermission(
    userPermissions,
    "gamifications.campaign_admin"
  );

  const ValidatorPermssion = checkPermission(
    userPermissions,
    "gamifications.campaign_validator"
  );


  const [campaignType, setCampaignType] = useState({});
  const [campaignCategory, setCampaignCategory] = useState({});
  const [rewardType, setRewardType] = useState({});
  const [campaignTypeList, setCampaignTypeList] = useState([]);
  const [rewardProvider, setRewardProvider] = useState({});

  const [filterData, setFilterData] = useState({
    name: "",
    status: queryParams.get("status") || "",
    provider_id: queryParams.get("provider_id") || "",
    provider: queryParams.get("provider") || "",
    reward_type: queryParams.get("reward_type") || "",
    category: queryParams.get("category") || "",
  });


  const getData = async (callback) => {
    dispatch(fetchCampaigns(getFilterData())).then((res) => {
      setListingLoading(false);
      const formattedData = res.payload.map(item => ({
        ...item,
        is_show_status: `${isShowUpdateStatus(item)}`

      }));

      setTempData([...formattedData]);
    });
  };

  const downloadRequiredData = async (callback) => {
    setListingLoading(true);
    dispatch(fetchUserById(localStorage.getItem("username"))).then(
      async (result) => {
        dispatch(fetchAllProviderList());
        dispatch(fetchCampaignConfig()).then((res) => {
          setCampaignType(res.payload.data.campaign_type[0]);
          setCampaignTypeList(res.payload.data.campaign_type);
        });

        getData();
      }
    );
  };


  const isShowUpdateStatus = (item) => {

    let isShow = true;

    if (item.status === "Draft" || item.status === "Rejected" || item.status === "Closed") {
      isShow = false;
    }

    if (!AdminPermssion && CampaignApproverPermssion) {
      if (item.status === "Pending Approval") {
        isShow = true;
      } else {
        isShow = false;
      }
    }

    if (!AdminPermssion && ValidatorPermssion) {
      isShow = false;
    }

    if (AdminPermssion && item.status === "Pending Nomination") {
      isShow = false;
    }


    return isShow;
  };

  // useEffect(() => {


  //   const formattedData = campaign_list.map(item => ({
  //     ...item,
  //     is_show_status: `${isShowUpdateStatus(item)}`

  //   }));

  //   setTempData([...formattedData]);
  // }, [campaign_list]);

  useEffect(() => {
    downloadRequiredData();
  }, []);

  useEffect(() => {
    delay = setTimeout(() => {
      getData();
    }, 500);
    return () => clearTimeout(delay);
  }, [filterData]);

  const actionTrigger = () => {
    setListingLoading(true);
    if (actionType === "Delete") {
      setShowDelete(false);
      let params = { reason: deleteReason, id: actionID }

      dispatch(deleteCampaignById({ data: params, id: actionID })).then((res) => {
        setDeleteReason("");
        getData();

      });
    }
  };

  const getFilterData = () => {

    let params = {};
    params = filterData;

    return params;
  };

  const handleChangeStatus = () => {
    getData();
  };

  const clearFilter = () => {
    navigate(REWARDS_CAMPAIGNS_LIST, { replace: true });
  }



  const handleTableClick = (type, id) => {
    if (type === "View Details") {
      navigate(`${REWARDS_CAMPAIGNS_DETAIL}?id=${id}`);
    } else if (type === "Delete") {
      setActionID(id);
      setActionType(type);
      if (type === "Delete") {
        setShowDelete(true);
      }
    }
    else {

      if (!AdminPermssion && CampaignApproverPermssion) {
        const campaign = tempData.find(campaign => campaign.pk === id);
        const campaignDetail = tempData.find(temp => temp.pk === id);
        setTempDate(moment());

        if (campaign.status == "Pending Approval" && CampaignApproverPermssion) {
          setTempStatusData(statusConfigForCampaignApprover);
        } else
          if ((campaign.status == "Approved" || campaign.status == "Rejected") && CampaignApproverPermssion) {

            setTempStatusData(statusConfigForPendingNomination);
          } else {
            setTempStatusData(statusConfigForPublishScheduled);
          }

        setTempId(campaign.pk);
        setTempStatus(campaign.status);
        setTempOldStatus(campaign.status);
        setTempStartDate(campaignDetail.publish_on);
        setTempEndDate(campaignDetail.publish_end);

        setShowUpdateStatus(true);
      } else {
        const campaign = tempData.find(campaign => campaign.pk === id);
        const campaignDetail = tempData.find(temp => temp.pk === id);
        setTempDate(moment());

        const currentIndex = statusConfig.findIndex(status => status.name === campaign.status);

        const nextStatuses = currentIndex !== -1 ? statusConfig.slice(currentIndex + 1) : [];

        setTempStatusData(nextStatuses);
        if (campaign.status == "Published" || campaign.status == "Scheduled") {
          setTempStatusData(statusConfigForPublishScheduled)
        }
        if (campaign.status == "Pending Approval" && CampaignApproverPermssion) {
          setTempStatusData(statusConfigForCampaignApprover);
        }
        else if ((campaign.status == "Approved" || campaign.status == "Rejected") && CampaignApproverPermssion) {

          setTempStatusData(statusConfigForPendingNomination);
        } else {
          if (AdminPermssion) {
            setTempStatusData(statusConfigForPublishScheduled);
          } else if (CampaignApproverPermssion) {
            setTempStatusData(statusConfigForPublishScheduled);
          }
        }

        if (campaign.status == "Pending Nomination") {
          setTempStatusData(statusConfigForPendingNomination);
        }
        setTempId(campaign.pk);
        setTempStatus(campaign.status);
        setTempOldStatus(campaign.status);
        setTempStartDate(campaignDetail.publish_on);
        setTempEndDate(campaignDetail.publish_end);

        setShowUpdateStatus(true);
      }



    }
  };

  const RefreshData = () => {
    getData();
  };




  const handleCreateAction = () => {
    navigate(REWARDS_CAMPAIGNS_ADD);
  };

  const icons = [
    ...(AddPermssion ? [{
      buttonName: "+ Add new",
      action: handleCreateAction,
    }] : []),
    {
      icon: RefreshIcon,
      title: "Refresh",
      action: RefreshData,
    },
    // {
    //   icon: ExportIcon,
    //   title: "Export",
    //   action: handleExport,
    // },
  ];

  const updateStatus = () => {
    setTimeChange(false);
    setTempStartDate("");
    setShowPublishDialog(false);
    setListingLoading(true);

    const getstatus = statusConfig.find(status => status.name === tempStatus);

    let params = { status: getstatus.id, updated_on: tempDate.format("YYYY-MM-DDTHH:mm:ss.SSSSSSZ") };
    if (tempStatus == "Rejected") {
      params = { status: getstatus.id, reason: rejectReason, updated_on: tempDate.format("YYYY-MM-DDTHH:mm:ss.SSSSSSZ") }
    }
    setTempId("");
    setTempStatus("");
    setShowUpdateStatus(false);

    if (getstatus.name == "Published" || getstatus.name == "Scheduled") {
      dispatch(generateReward({ data: params, id: tempId })).then((rewardRes) => {
        console.log(rewardRes);

        if (rewardRes.payload.status_code === 200) {
          getData();
          setListingLoading(false);
          setRejectReason("");
        } else {
          alert(rewardRes.payload.message);
          setListingLoading(false);

        }
      });
    } else {
      dispatch(updateCampaignStatus({ data: params, id: tempId })).then((res) => {
        console.log(res);

        if (res.payload.status_code === 200) {
          getData();
          setListingLoading(false);
          setRejectReason("");

        } else {
          alert(res.payload.message);
          setListingLoading(false);

        }
      });
    }

  };

  const checkTimeForPublish = () => {
    setTempDate(moment());

    if (tempStatus == "Published") {
      const isPassed = moment().isAfter(moment(tempStartDate));

      if (isPassed) {
        setTimeChange(true);

      } else {
        setShowPublishDialog(true);
      }

    } else {
      updateStatus();
    }
  }

  const checkEndDateForPublish = () => {
    const isPassed = moment().isAfter(moment(tempEndDate));

    if (isPassed) {
      setShowEndDateError(true);
    } else {
      updateStatus();
    }
  }


  const getTime = () => {
    return tempDate.format('DD-MMM-YYYY hh:mm A');
  }

  return (
    <>
      {viewPermssion ? (
        <div className="container">

          {showEndDateError && (
            <Dialog
              className="alert-form"
              title={"Alert"}
              width={400}
              // height={280}
              onClose={() => setShowEndDateError(false)}
            >
              <p>End Date cannot be earlier than Start Date!</p>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "20px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "150px",
                    height: "30px",
                    borderRadius: "10px",
                    background: "#eb6e1f",
                    color: "white",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setShowEndDateError(false)
                    navigate(`${REWARDS_CAMPAIGNS_ADD}?id=${tempId}`);
                  }}
                >
                  Change
                </div>
              </div>
            </Dialog>
          )}

          {timeChange && (
            <Dialog
              className="alert-form"
              title={"Alert"}
              width={400}
              // height={280}
              onClose={() => setTimeChange(false)}
            >
              <p>
                The selected publishing time has already passed. Could we proceed by
                submitting the new publish time for {getTime()}?
              </p>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "20px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "150px",
                    height: "30px",
                    borderRadius: "10px",
                    background: "white",
                    color: "#eb6e1f",
                    cursor: "pointer",
                    border: "1px solid #eb6e1f",
                  }}
                  onClick={() => {
                    setTimeChange(false);
                    setTempStartDate("");
                  }}
                >
                  Go back
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "150px",
                    height: "30px",
                    borderRadius: "10px",
                    background: "#eb6e1f",
                    color: "white",
                    cursor: "pointer",
                  }}
                  onClick={() => checkEndDateForPublish()}
                >
                  Submit
                </div>
              </div>
            </Dialog>
          )}


          {showPublishDialog && (
            <Dialog
              className="alert-form"
              title={"Manual Publish Confirmation"}
              width={400}
              // height={280}
              onClose={() => setShowPublishDialog(false)}
            >
              <p>
                You've configured a Start Date and Time for this Campaign.
                By manually publishing now, the Start Date and Time will be updated to the current time. The End Date and Time will remain unchanged.
              </p>
              <p>Do you want to continue?</p>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "20px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "150px",
                    height: "30px",
                    borderRadius: "10px",
                    background: "white",
                    color: "#eb6e1f",
                    cursor: "pointer",
                    border: "1px solid #eb6e1f",
                  }}
                  onClick={() => {
                    setTimeChange(false);
                    setTempStartDate("");
                    setShowPublishDialog(false);
                  }}
                >
                  Cancel
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "150px",
                    height: "30px",
                    borderRadius: "10px",
                    background: "#eb6e1f",
                    color: "white",
                    cursor: "pointer",
                  }}
                  onClick={() => updateStatus()}
                >
                  Publish Now
                </div>
              </div>
            </Dialog>
          )}

          {showUpdateStatus && (
            <ShowDialog
              cancelbtn={() => {
                setShowUpdateStatus(false);
                setTempStatus("");
              }}
              title={"Update Status"}
              dropdownContent={"Set status"}
              dropdown={true}
              cancelContent={"Cancel"}
              confrimContent={"Update"}
              isDisabled={tempStatus == 'Rejected' ? (tempStatus == tempOldStatus || rejectReason.trim() === "") : tempStatus == tempOldStatus}
              children={
                tempStatus == "Rejected" && (
                  <div className="campaigns-dialog-reason-div">
                    <div>Reason <span style={{ color: "red" }}>*</span></div>
                    <div>
                      <TextArea placeholder="Enter Reason" style={{ "borderRadius": "5px", minHeight: "100px" }} value={rejectReason} onChange={(e) => setRejectReason(e.target.value)} />
                    </div>
                  </div>
                )
              }
              confrinbtn={checkTimeForPublish}
              dropdownData={tempStatusData.map(status => status.name)}
              dropdownOnChange={(e) => setTempStatus(e)}
              dropdownValue={tempStatus}
            />
          )}

          <TableHeader title={"Campaigns Listing"} icons={icons} />
          {config_list.reward_type && campaignType.categories && provide_list && (
            <Filter
              reward_type_list={config_list ? config_list.reward_type : []}
              campaign_category_list={campaignType ? campaignType.categories : []}
              reward_provider_list={provide_list ? provide_list : []}
              filterData={filterData}
              setFilterData={setFilterData}
              handleChangeStatus={handleChangeStatus}
              clearFilter={clearFilter}
            />
          )

          }

          {showDelete && (
            <ShowDialog
              title={"Please Confirm!"}
              content={"Are you sure you want to delete?"}
              cancelContent={"Cancel"}
              confrimContent={"Delete"}
              children={

                <div className="campaigns-dialog-reason-div">
                  <div>Reason <span style={{ color: "red" }}>*</span></div>
                  <div>
                    <TextArea placeholder="Enter Reason" style={{ "borderRadius": "5px", minHeight: "100px" }} value={deleteReason} onChange={(e) => setDeleteReason(e.target.value)} />
                  </div>
                </div>

              }
              cancelbtn={() => setShowDelete(false)}
              confrinbtn={actionTrigger}
            />
          )}

          {(<div className="campaigns_child_box_main_detail_box">


            {loading ? (
              <Loader
                type="converging-spinner"
                style={{
                  width: "100%",
                  height: "calc(100vh - 165px)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "#ffffff4d",
                  position: "absolute",
                  zIndex: "999",
                }}
              />
            ) : (
              <Reusable_table
                key={tempData.map(i => i.status).join("-")}
                header={ConfigData}
                data={tempData}
                pagination={true}
                calculatePagi={true}
                pageChangeLoading={false}
                showRow={true}
                checkbox={false}
                //   handleTableClick={handleTableClick}
                handleAction={handleTableClick}
                maxHeight={""}
                maxWidth={"calc(100vw - 240px)"}
              />
            )}
          </div>
          )}
        </div>
      ) : (
        <PermissionDeninedPage
          height={"calc(100% - 76px)"}
          title={"Sorry, You don't have permission to access this page!"}
        />
      )}
    </>
  );
};
